export const NEW_DASHBOARD_ID = 'new';